import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Dialog, DialogTitle, Tab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import MapEditorLayerCreateDialogForm from "../MapEditorLayerCreateDialogForm";
import MapEditorLayerImport from "../MapEditorLayerImport";

type Props = {
    open: boolean;
    onClose: () => void;
    onFinished: (layerId: string) => void;
    projectId: string;
};

export default function MapEditorLayerCreateDialog({ open, onClose, onFinished, projectId }: Props) {
    const { t } = useTranslation("mapEditor");

    const [activeTab, setActiveTab] = useState(0);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle variant="h3">{t("mapEditorLayerCreateDialog.title")}</DialogTitle>

            <TabContext value={activeTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList onChange={(_, newValue) => setActiveTab(newValue)}>
                        <Tab label={t("mapEditorLayerCreateDialog.create")} value={0} />
                        <Tab label={t("mapEditorLayerCreateDialog.import")} value={1} />
                    </TabList>
                </Box>
                <TabPanel value={0} sx={{ padding: 0 }}>
                    <MapEditorLayerCreateDialogForm onClose={onClose} projectId={projectId} onFinished={onFinished} />
                </TabPanel>
                <TabPanel value={1} sx={{ padding: 0 }}>
                    <MapEditorLayerImport projectId={projectId} onClose={onClose} onFinished={onFinished} />
                </TabPanel>
            </TabContext>
        </Dialog>
    );
}
